<template>
    <div class="page">
        <app-header title="Neue Beteiligung!":close="'true'" :path="'meine_trends'"></app-header>
        <div class="pic">
            <div class="media">
                <img class="m-4" src="../../assets/images/Bildschirmfoto.png">

                <div class="media-body">
                    <h4>Kombination</h4>
                    <h5>Bligg</h5>
                    <a>5 Titel mit Beteiligung</a>
                </div>
            </div>
        </div>
        <div class="table">
        <app-item v-for="item in items" :item="item"></app-item>
        </div>
        <footer>
            <form>
                <router-link :to="{name: 'ablehnen'}" class="outline" tag="button">Ablehnen</router-link>
                <router-link :to="{name: 'meine_trends'}" class="full" tag="button">Annehmen</router-link>
            </form>
        </footer>
    </div>
</template>

<script>
    import Item from './Item.vue';
    import Header from '../Header.vue';
    export default {
        components: {
            appItem: Item,
            appHeader: Header
        },
        computed: {
            items() {
                return this.$store.getters.Neue;
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../assets/css/style';
    .page{
        padding-top:60px;
        overflow: hidden;
    }

    .pic{
        margin: auto;
        margin: 5px 0 0 5px;
        .media{
            display: table;
            .media-body{
                display: table-cell;
                vertical-align: middle;
                h4,h5{
                    font-size:1.5rem;
                }
                h4{
                    font-weight: 600;
                    margin-bottom: 3px;
                }
                a{
                    font-size:1.3rem;
                    font-weight: 400;
                    color: $lila;
                    padding-top:0px;
                    display:inline-block;
                }
            }
        }

    }
    .table{
        border-top:1px solid $line_color;
        width:90%;
        margin:2px auto;
    }
    footer{
        border-top:2px $footer_line_color solid;
        box-shadow: 0px -2px 34px 0px rgba(223,223,223,1);

        position: fixed;
        width: 100%;
        bottom: 0;
        height: 67px;
        background: white;
        display: table;
        form{
            display: table-cell;
            vertical-align: middle;
            text-align: center;
            button{
                font-size:1.5rem;
                margin:10px;
                padding: 8px 25px;
                margin:2px;
                border-radius: 5px;
                border: none;
                font-weight: 700;
                &:first-of-type{
                    background-color: $button_outline-backGroundColor;
                    color: $button-outline-color;
                }
                &:last-of-type{
                    background-color: $button_full_backGroundColor;
                    color: $button_full_color;
                }
            }

        }
    }

</style>



// WEBPACK FOOTER //
// src/components/neue_beteiligung/Neue.vue